<template>
  <VueFinalModal
    v-model="showModal"
    classes="overflow-y-auto"
    content-class="p-4 flex flex-wrap justify-center items-center w-full h-full box-border overflow-hidden"
    :esc-to-close="!showLargeImg"
  >
    <Transition
      mode="out-in"
      enter-active-class="transition duration-300 transform"
      enter-from-class="opacity-0 -translate-y-8"
      leave-active-class="duration-300 transform"
      leave-to-class="opacity-0 -translate-y-8"
      appear
    >
      <div v-if="!show" class="text-center p-6 text-neutral-700 dark:text-neutral-400 bg-neutral-200 dark:bg-neutral-700 rounded-lg w-full max-w-80">
        <UiLoader size="48px" class="inline-block mb-4" />
        <div class="text-base font-semibold mb-1">{{ $t('feedback.loading') }}</div>
        <div class="text-sm">{{ $t('feedback.pleaseWait') }}</div>
      </div>
      <div v-else class="absolute top-0 left-0 z-50 h-full max-h-full w-screen overflow-hidden bg-black/80 box-border p-6 flex items-center justify-center">
        <div class="h-full relative card-communication" id="card-communication">
          <UiButton
            v-if="!showLargeImg"
            type="ghost"
            icon="x"
            aria-label="Fechar"
            class="absolute top-2 right-2 aspect-square p-1"
            @click="close"
          />

          <div class="box-border w-full flex flex-col gap-4 items-end">
            <div v-if="hasControls" class="box-border w-full flex justify-center items-center gap-2 mt-6">
              <div
                ref="backButtonRef"
                class="button-arrow bg-[#E5D0FF] dark:bg-[#C091FC]"
                :class="{'opacity-0 pointer-events-none': arrivedState.left}"
                @click="stepBack"
              >
                <UiIcon icon="chevron-left" stroke-width="1.5" class="w-full h-full" />
              </div>
              <div
                v-if="communications?.length > 1"
                ref="communicationsRef"
                class="w-full flex gap-2 overflow-hidden justify-start touch-manipulation scroll-smooth p-2"
              >
                <img
                  v-for="(communication, i) in communications" :key="i"
                  :src="getImage(communication)"
                  class="h-[50px] w-[50px] rounded-full object-cover cursor-pointer"
                  :class="{'border-2 border-white ring-2 ring-[--c-primary-400] ring-offset-2': indexCommunication === i}"
                  alt="Imagem da comunicação"
                  @click="changeCommunication(i)"
                />
              </div>
              <div
                :class="['button-arrow bg-[#E5D0FF] dark:bg-[#C091FC]', {'opacity-0 pointer-events-none': arrivedState.right}]"
                @click="stepNext"
              >
                <UiIcon icon="chevron-right" stroke-width="1.5" class="w-full h-full" />
              </div>
            </div>
          </div>
          <div class="box-border w-full flex flex-col justify-between items-center gap-3 overflow-hidden">
            <div class="relative over">
              <transition
                mode="out-in"
                enter-active-class="duration-300 ease-out"
                :enter-from-class="transitionDirection === 'next' ? 'transform opacity-0 translate-x-6' : 'transform opacity-0 -translate-x-6'"
                leave-active-class="duration-200 ease-in"
                :leave-to-class="transitionDirection === 'next' ? 'transform opacity-0 -translate-x-6' : 'transform opacity-0 translate-x-6'"
              >
                <div
                  v-if="currentPost.linkImage"
                  :key="currentPost.linkImage"
                  class="relative rounded-md overflow-hidden h-full max-h-[810px] group"
                >
                  <img
                    :src="currentPost.linkImage"
                    alt=""
                    :height="724"
                    class="h-full max-h-[810px]"
                    :class="{ 'opacity-0': showLargeImg }"
                  />
                  <div class="flex items-center justify-center absolute inset-0 bg-black/70 opacity-0 group-hover:opacity-100 transition-all delay-150">
                    <div class="flex flex-wrap gap-4">
                      <div class="group/img">
                        <div class="group-hover/img:-translate-y-4 transition-transform delay-150 bg-black/20 p-4 aspect-square border-2 border-white/80 rounded-full flex flex-col items-center cursor-pointer text-xs shadow-2xl" @click="showLargeImg = true">
                          <UiIcon icon="maximize" size="48" />
                          Ver imagem
                        </div>
                      </div>
                      <div v-if="false" class="group/vw">
                        <div class="group-hover/vw:-translate-y-4 transition-transform bg-black/20 p-4 aspect-square border-2 border-white/80 rounded-full flex flex-col items-center cursor-pointer text-xs" @click="() => visitLink(currentPost.linkImage)">
                          <UiIcon icon="arrow-right" size="48" />
                          Visitar Link
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </transition>
              <!-- <img
                v-if="currentPost?.linkImage"
                class="w-full h-auto max-h-[724px] rounded-md object-contain grow cursor-pointer"
                :src="currentPost?.linkImage"
                alt="Imagem de destaque"
                @click="showLargeImg = true"
              /> -->
              <div class="block md:hidden absolute z-1 -bottom-2 -right-2 drop-shadow-2xl transition-opacity">
                <UiIcon icon="hand-click" class="animate-bounce text-neutral-300 text-lg" />
              </div>
              <VueEasyLightbox
                :visible="showLargeImg"
                :imgs="allImgs"
                :index="indexPost"
                @hide="showLargeImg = false"
                @onIndexChange="(_, n) => indexPost = n"
              />
            </div>

            <OverlayScrollbarsComponent v-if="currentPost.content" defer :options="{ scrollbars: { autoHide: 'leave' } }">
              <div class="flex flex-col gap-3 px-4">
                <div class="box-border text-[#212121] dark:text-[#FDFDFD] text-sm md:text-base w-full leading-[17px] font-semibold p-0 m-0">{{ currentPost.title }}</div>
                <QuillEditor
                  v-if="currentPost.content"
                  v-model="currentPost.content"
                  :id="`post-${indexPost}`"
                  class="quill-preview"
                  read-only
                  toolbar="none"
                  theme="snow"
                />
              </div>
            </OverlayScrollbarsComponent>
            <div v-if="showButtons" class="w-full flex items-center justify-center gap-4">
              <UiButton type="primary" outline class="p-2" :disabled="(isFirstCommunication && isFirstPost)" @click="previousPost">
                <UiIcon icon="arrow-left" class="text-[#212121] dark:text-[--c-primary-500]" />
              </UiButton>
              <div v-if="qtdPosts > 1" class="flex gap-1 transition-all delay-150">
                <div
                  v-for="(_, i) in qtdPosts"
                  :key="i"
                  :class="['h-[8px] rounded-md', {
                    'bg-[--c-primary-600] w-4': indexPost === i,
                    'bg-[#D9D9D9] w-2': indexPost !== i
                  }]"
                ></div>
              </div>
              <UiButton type="primary" outline class="p-2" :disabled="(isLastCommunication && isLastPost)" @click="nextPost">
                <UiIcon
                  icon="arrow-right"
                  stroke-width="1.5"
                  class="text-[#212121] dark:text-[--c-primary-500]"
                />
              </UiButton>
            </div>
            <div v-if="false" class="w-full text-black box-border text-sm flex flex-wrap justify-center md:justify-between items-center gap-4">
              <label v-if="canDisable" for="showAgain" class="cursor-pointer truncate">
                <input v-model="currentCommunication.dontDisplay" type="checkbox" name="showAgain" id="showAgain" /> {{ $t('input.notShowAgain') }}
              </label>
              <div class="grow-0 md:grow"></div>
              <UiButton type="primary" outline class="text-sm px-4 py-2 outline-[0px] uppercase" @click="close">
                {{ $t('button.close') }}
              </UiButton>
            </div>
          </div>
        </div>
      </div>
    </Transition>
  </VueFinalModal>
</template>

<script setup lang="ts">
import { ref, computed, nextTick, watch } from 'vue'
import { VueFinalModal } from 'vue-final-modal'
import { useScroll } from '@vueuse/core'
import webStorage from '@/common/webStorage'
import { useComunicacoesStore } from '@/stores'
import { safeCopy, toast, validateLink } from '@/common/util'
import { OverlayScrollbarsComponent } from 'overlayscrollbars-vue'
import 'overlayscrollbars/overlayscrollbars.css'
import QuillEditor from '@/components/ui/quillEditor.vue'

import UiButton from '@/components/ui/button.vue'
import UiIcon from '@/components/ui/icon.vue'
import UiLoader from '@/components/ui/loader.vue'

import type { CommunicationsType } from '@/types/types'
import { useRouter } from 'vue-router'

const emit = defineEmits(['onClose'])

const props = defineProps<{
  preview?: boolean,
  showAllCommunication?: boolean
}>()

const comunicacoesStore = useComunicacoesStore()
const router = useRouter()

const showLargeImg = ref(false)
const showModal = ref(false)
const show = ref(false)
const communications = ref<CommunicationsType[]>([])
const indexCommunication = ref(0)
const indexPost = ref(0)
const transitionDirection = ref('next')
const communicationsRef = ref()
const backButtonRef = ref<HTMLDivElement | null>(null)

const { arrivedState } = useScroll(communicationsRef)

const showButtons = computed(() => communications.value.length > 1 || currentCommunication.value?.posts?.length > 1)
const canDisable = computed(() => !props.preview && isLastPost.value && !currentCommunication.value.forceDisplay)
const currentCommunication = computed(() => communications.value[indexCommunication.value])
const currentPost = computed(() => currentCommunication.value?.posts[indexPost.value])
const allImgs = computed(() => currentCommunication.value.posts.map(post => post.linkImage))

const isLastPost = computed(() => currentCommunication.value?.posts.length === (indexPost.value + 1))
const isFirstPost = computed(() => indexPost.value === 0)
const isLastCommunication = computed(() => communications.value.length === (indexCommunication.value + 1))
const isFirstCommunication = computed(() => indexCommunication.value === 0)
const qtdPosts = computed(() => currentCommunication.value?.posts?.length)
const hasNextCommunication = computed(() => !!communications.value[indexCommunication.value + 1])
const hasPreviousCommunication = computed(() => !!communications.value[indexCommunication.value - 1])
const hasControls = computed(() => communicationsRef.value?.scrollWidth > communicationsRef.value?.clientWidth)
const noCoverImage = new URL('../../../assets/placeholder/no_cover.jpg', import.meta.url).href

watch(
  () => indexPost.value,
  (newVal, oldVal) => {
    transitionDirection.value = newVal > oldVal ? 'next' : 'prev'
    embededVideo()
  }
)

const getImage = (communication: CommunicationsType) => communication?.posts.find(post => !!post.linkImage)?.linkImage || noCoverImage

const embededVideo = () => {
  nextTick(() => {
    document.querySelectorAll(`.v-show-content p`).forEach(el => {

      const isYoutube = validateLink.youtube(el?.textContent)
      const isVimeo = validateLink.vimeo(el?.textContent)

      if (isYoutube || isVimeo) {
        let videoId = ''
        let srcLink = ''

        if (isYoutube) {
          videoId = el.textContent.includes('v=') ? el.textContent.split('v=')[1] : el.textContent.split('/').at(-1)
          videoId = videoId.includes('&list') ? videoId.split('&list')[0] : videoId
          srcLink = `https://www.youtube.com/embed/${videoId}`
        }

        if (isVimeo) {
          videoId = el.textContent.split('/').at(-1)
          srcLink = `https://player.vimeo.com/video/${videoId}`
        }

        const newEl = `<iframe style="width: 100%;"  height="460" src="${srcLink}" async frameborder="0" allow="accelerometer; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>`
        const newElm = document.createElement('div')
        newElm.insertAdjacentHTML('beforeend', newEl)
        el.replaceWith(newElm)
      }
    })
  })
}

const stepBack = () => {
  communicationsRef.value.scrollLeft -= 288 * 1
}

const stepNext = () => {
  const child0 = communicationsRef.value.children[0]?.getBoundingClientRect().x
  const child1 = communicationsRef.value.children[1]?.getBoundingClientRect().x
  const padding = 20
  const extraSpace = arrivedState.left ? backButtonRef.value.getBoundingClientRect().width + padding : 0

  const scrollAmount = child1 - child0 - extraSpace
  communicationsRef.value.scrollLeft += scrollAmount > 0 ? scrollAmount : 20
}

const previousPost = () => {
  nextTick(() => {
    isFirstPost.value && hasPreviousCommunication.value
      ? changeCommunication((indexCommunication.value - 1))
      : indexPost.value -= 1
  })
}

const nextPost = () => {
  nextTick(() => {
    isLastPost.value && hasNextCommunication.value
      ? changeCommunication((indexCommunication.value + 1))
      : indexPost.value += 1
  })
}

const reset = () => {
  indexCommunication.value = 0
  indexPost.value = 0
}

const changeCommunication = (index: number) => {
  nextTick(() => {
    indexPost.value = 0
    indexCommunication.value = index
  })
}

const open = async (id: string, communication?: CommunicationsType) => {
  reset()
  show.value = false
  showModal.value = true

  if (props.showAllCommunication) {
    const data = await comunicacoesStore.getUserCommunication(props.showAllCommunication)
    if (!data) {
      toast.error({
        title: 'Erro',
        message: 'Falha ao carregar comunicações.'
      })

      return
    }

    communications.value = safeCopy(data)
  } else if (!id && !props.preview) {
    communications.value = safeCopy(comunicacoesStore.userCommunications)
  }

  if (!id && communication) {
    communications.value = [communication]
  }

  if (id && props.preview) {
    const data = await comunicacoesStore.getById(id)
    if (!data) {
      toast.error({
        title: 'Erro',
        message: 'Falha ao carregar comunicação.'
      })
      return
    }
    communications.value = [data]
  }

  if (!communications.value.length) {
    showModal.value = false
    return
  }

  show.value = true

  embededVideo()
}

const close = () => {
  // Verifica e salva alterações de "Não exibir novamente"
  !props.preview && comunicacoesStore.toggledontDisplay([...communications.value])

  webStorage.removeItem('showCommunication')
  showModal.value = false
  emit('onClose')
  reset()
}

// STUB: Essa função não vai ser chamada ainda porque não há integração
const visitLink = (_imgUrl: string) => {
  // STUB
}

defineExpose({
  open,
  close
})
</script>

<style scoped lang="scss">
.card-communication {
  @apply flex flex-col gap-4 rounded-2xl bg-neutral-50 dark:bg-neutral-800/80 py-3 px-4
  max-h-full w-[800px] max-w-full;
}

.quill-preview {
  @apply border-none;
}

.button-arrow {
  @apply p-1 border-[1px] border-solid border-[#C091FC] text-[#471F79] rounded-md bg-transparent;
}

*::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}

*::-webkit-scrollbar-track {
  background: transparent;
  margin: 3px 0px;
  border-radius: 6px;
}

*::-webkit-scrollbar-thumb {
  background-color: rgba(200, 200, 200, .6);
  border-radius: 6px;
}

.v-note-wrapper {
  min-height: auto !important;
}
</style>

<style lang="scss">
.dark {
  .quill-preview {
    background-color: rgb(38 38 38) !important;
    color: #FDFDFD !important;
  }
}

.quill-preview {
  hr {
    background-color: #D9D9D9 !important;
  }
}
</style>
